import { z } from 'zod'

export const pageDataValueSchema = z.object({
  table: z.object({
    order: z.string().array().optional(),
    visibility: z.union([z.record(z.string(), z.boolean()).optional(), z.unknown().array()]),
  }),
})

export const pageDataSchema = z.object({
  page: z.string(),
  user_id: z.number(),
  value: pageDataValueSchema,
})
